import React from "react";
import {observer} from "mobx-react";
import {
    IPsoAgreementViewModel
} from "../../../../services/booking/models/pso/agreements/base/pso-agreement.view-mode.interface";
import styled from "styled-components";
import {CardBox} from "../../../../basic-components/card/card.box";
import {PersonCircleFilledIcon} from "../../../../assets/svg/person-circle-filled.icon";

const PsoAgreementContainerBox = styled(CardBox)`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: ${props => props.theme.spacing.flexGap24};
    width: 100%;
`
const PassengerNameBox = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: ${props => props.theme.spacing.flexGap16};
    font-weight: ${props => props.theme.fontWeight.bold};
`


interface PsoAgreementComponentProps {
    agreement: IPsoAgreementViewModel<any>
}
export const PsoAgreementComponent: React.FC<PsoAgreementComponentProps> = observer((props) => {
    return (
        <PsoAgreementContainerBox>
            <PassengerNameBox>
                <PersonCircleFilledIcon/>
                <span>
                    {props.agreement.passengerFullName}
                </span>
            </PassengerNameBox>
            {props.agreement.renderComponent()}
        </PsoAgreementContainerBox>
    )
})

